export function Footer() {
   return (
     <footer style={{ textAlign: 'center', padding: '1rem', backgroundColor: '#f0f0f0' }}>
       <p>&copy; 2024 Matheus Martins. Todos os direitos reservados.</p>
     </footer>
   );
 }
 